export const ALLOWED_COUNTRIES = ['AT', 'CH', 'DE', 'NL'];
